import { API_URL } from 'src/data/Api';
import { GLOB } from 'src/util/Glob';
import { CreatableType, folderCreatePayload, HierarchyAction, HierarchyDomain } from './hierarchyTypes';

// Dashboard hierarchy: POST/PUT/DELETE /api/dashboard/v1/{type}; reload via reloadDashboards().
export const dashboardDomain: HierarchyDomain = {
  createUrl: (type: CreatableType) => `${API_URL.DASHBOARD}/${type}`,
  buildCreatePayload: folderCreatePayload,
  parseCreated: (data) => ({ id: data.id ?? '', label: data.label ?? '' }),
  modifyUrl: (type: string, id: string) => `${API_URL.DASHBOARD}/${type}/${id}`,
  childUrl: (type, id) => `${API_URL.DASHBOARD_MENU}/${type}/${id}`,
  reload: () => GLOB.menuService.reloadDashboards(),
  actions: [
    HierarchyAction.FOLDER,
    HierarchyAction.DASHBOARD,
    HierarchyAction.GROUP,
    HierarchyAction.RENAME,
    HierarchyAction.DELETE,
  ],
};
